// @flow
import type { PermissionsGateType } from '@shared/model/components/permissionsGateType';
import { useContext } from 'react';
import { PermissionGateContext } from '@shared/store';

function PermissionsGate({ children, scopes = [] }: PermissionsGateType): React$Node {
	const permissions = useContext(PermissionGateContext) || [];
	const hasPermission = (permission) => permissions.includes(permission);
	const permissionGranted = scopes.some(hasPermission);

	if (!permissionGranted) return null;

	return children;
}

export default PermissionsGate;
